<template>
  <div class="page-wrap">
    <div class="page-container">
      <div class="search-card">
        <el-form :label-position="right" label-width="120px">
          <el-form-item label="平台编码:">
            <el-select v-model="form.platformCode" filterable clearable placeholder="请选择平台编码" size="mini"
              style="width:360px">
              <el-option v-for="item in platformList" :key="item.platformCode" :label="item.platformName"
                :value="item.platformCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="免费/付费:">
            <el-radio-group v-model="form.playletSeriesUrlType" size="mini">
              <el-radio-button :label="'IAA'">免费</el-radio-button>
              <el-radio-button :label="'IAP'">付费</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="番茄类型:">
            <el-select v-model="fqAccountValue" clearable placeholder="请先选择" size="mini" style="width:260px">
              <el-option v-for="item in fqAccountOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查询短剧名称:">
            <el-input v-model="form.name" placeholder="可模糊查询，如果不存在请添加短剧" clearable size="mini"
              style="width:360px"></el-input><el-button type="success" size="mini" @click="booklistFun()">搜索</el-button>
          </el-form-item>
          <el-form-item label="短剧:">
            <el-select v-model="form.bookId" filterable clearable placeholder="请先查询短剧，再选择" size="mini"
              style="width:360px">
              <el-option v-for="item in tableData" :key="item.platformDramaId" :label="item.name"
                :value="item.platformDramaId"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="推广链接:">
            <el-input v-model="form.promotionUrl" type="textarea" :rows="6" placeholder="请输入内容推广链接" />
          </el-form-item>
          <el-form-item label="推广链名称:">
            <el-input v-model="form.promotionName" placeholder="填写推广链接名称" clearable size="mini"
              style="width:360px"></el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input v-model="form.remark" placeholder="选填，备注" clearable size="mini" style="width:260px"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="success" size="mini" @click="fanqiesyncPromotionListFun()">从平台拉取已有推广链接</el-button>
            <!-- <el-button size="mini" @click="handleResetPackage()">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { bookplatformList, bookaddPromotion, booklist, fanqiesyncPromotionList } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { reactive, toRefs, watch, computed } from 'vue'

export default {
  name: 'ylySDcreatePromotion',
  components: {},
  // 声明组件抛出的事件（推荐加上）
  emits: ['sdgetCannelFun'],
  props: ['data'],
  setup(props, context) {
    const { emit } = context
    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    const today = new Date()
    const beginDate = new Date(today)
    beginDate.setDate(today.getDate() - 90)

    const state = reactive({
      //番茄账号
      fqAccount: [
        { label: '端原生付费漫剧', value: '1855633968499864' },
        { label: '端原生免费漫剧', value: '1855633968499848' },
        { label: '端原生付费短剧', value: '1851001214864440' },
        { label: '端原生免费短剧', value: '1851001214864424' }
      ],
      //番茄账户类型
      fqAccountValue: '',
      //短剧数据
      tableData: [],
      // 条数
      pagesize: 100,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      //所有启用的平台的数据
      platformList: [],
      //短剧重置数据
      // restform: {
      //   name: '',
      //   platformCode: '',
      //   bookId: '',
      //   promotionName: '',
      //   promotionUrl: '',
      //   remark: '',
      //   playletSeriesUrlType: 'IAP'
      // },
      beginDate: formatDate(beginDate),
      endDate: formatDate(today),
      //添加短剧的数据
      form: {
        name: JSON.parse(JSON.stringify(props.data.selectPromotionData)),
        platformCode: JSON.parse(JSON.stringify(props.data.platformCode)),
        bookId: '',
        promotionName: '',
        promotionUrl: '',
        remark: '',
        playletSeriesUrlType: 'IAP'
      },

      //生成推广链接
      // createPromotionFun: () => {
      //   const datas = {
      //     platformCode: state.form.platformCode,
      //     bookId: state.form.bookId,
      //     promotionUrl: state.form.promotionUrl,
      //     promotionName: state.form.promotionName,
      //     remark: state.form.remark,
      //     playletSeriesUrlType: state.form.playletSeriesUrlType,
      //     distributorId: '123',
      //     type: 2,
      //   }
      //   bookaddPromotion(datas).then((res) => {
      //     // 修复：= 改为 === 判断
      //     if (res.code === 200) {
      //       ElMessage.success('手动添加推广链接成功')
      //       state.handleResetPackage()
      //       emit('sdgetCannelFun')

      //     }
      //   })
      // },
      // 从平台拉取链接
      fanqiesyncPromotionListFun: () => {
        const datas = {
          distributorId: state.fqAccountValue,
          platformCode: state.form.platformCode,
          bookId: state.form.bookId,
          beginDate: state.beginDate,
          endDate: state.endDate,
          playletSeriesUrlType: state.form.playletSeriesUrlType,
        }
        fanqiesyncPromotionList(datas).then((res) => {
          // // 修复：= 改为 === 判断
          if (res.code === 200) {
            ElMessage.success('从平台拉取链接成功')
            // state.handleResetPackage()
            emit('PTgetCannelFun')

          }
        })
      },

      //重置短剧
      handleResetPackage: () => {
        // 深拷贝 restform，切断引用
        // state.form = JSON.parse(JSON.stringify(state.restform))
        // state.form
        // state.tableData = []
      },


    })





    //短剧分页查询
    const booklistFun = () => {
      const datas = {
        platformCode: state.form.platformCode,
        platformDramaId: '',
        name: state.form.name,
        currenPage: state.currentPage,
        size: state.pagesize,
      }
      booklist(datas).then((res) => {
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
        state.tableData = res.data.data
        if (res.data.data.length == 0) {
          ElMessage.warning('短剧不存在，请检查短剧名称或者手动添加短剧')
          state.form.bookId = ''
        } else {
          ElMessage.success('查询成功，请选择短剧')
        }

      })
    }

    //番茄类型下拉根据免费/付费联动过滤
    const fqAccountOptions = computed(() => {
      if (state.form.playletSeriesUrlType === 'IAA') {
        return state.fqAccount.filter((item) => item.value === '1855633968499848' || item.value === '1851001214864424')
      }
      if (state.form.playletSeriesUrlType === 'IAP') {
        return state.fqAccount.filter((item) => item.value === '1855633968499864' || item.value === '1851001214864440')
      }
      return state.fqAccount
    })

    //切换免费/付费时，若已选番茄类型不在可选范围内则清空，避免误选不匹配
    watch(() => state.form.playletSeriesUrlType, () => {
      const validValues = fqAccountOptions.value.map((item) => item.value)
      if (state.fqAccountValue && !validValues.includes(state.fqAccountValue)) {
        state.fqAccountValue = ''
      }
    })

    //分销平台下拉框（查询所有启用的平台）
    const bookplatformListFun = () => {
      bookplatformList().then((res) => {
        state.platformList = res.data
      })
    }

    bookplatformListFun()
    if (state.form.name) { booklistFun() }

    return {
      ...toRefs(state),
      booklistFun,
      bookplatformListFun,
      fqAccountOptions,
    }
  }
}
</script>

<style lang="scss" scoped>
// 全局页面浅色渐变背景
.page-wrap {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

// 搜索卡片：毛玻璃、大圆角、弥散柔和阴影
.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  transition: all 0.32s ease;
}

// ========= ElementPlus 组件深度修改 现代UI 大圆角+hover平滑动画 =========
:deep() {

  // 输入框、选择器大圆角
  .el-input__inner,
  .el-select .el-input__inner {
    border-radius: 12px !important;
    border-color: #e2e8f0;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);

    &:hover {
      border‑color: #b8c8e3;
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.08);
    }

    &:focus {
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    }
  }

  // 按钮统一大圆角+平滑hover微交互
  .el-button {
    border‑radius: 12px !important;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);
    box‑shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

    &:hover {
      transform: translateY(-1px);
      box‑shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
    }

    &:active {
      transform: translateY(0px);
    }
  }
}
</style>
